<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BaseSvgSpotEntity',
  props: {
    backgroundColor: {
      type: String,
      required: true
    },
    borderColor: {
      type: String,
      required: true
    },
    rotation: {
      type: Number,
      default: 0 // Rotation degree (0, 90, 180, 270)
    },
    scale: {
      type: Number,
      default: 1
    }
  }
});
</script>
